export const productButtonOnClick = () => {
  const productButton = document.querySelectorAll('.product-button');
  const hiddenInput = document.createElement("input");
  hiddenInput.type = "hidden";
  hiddenInput.name = "sector_product_id";
  document.body.appendChild(hiddenInput);

  for (var i = 0; i < productButton.length; i++) {
    productButton[i].addEventListener("click", function () {
      hiddenInput.value = this.dataset.id;
      hiddenInput.dataset.periodical = this.dataset.periodical;
    });
  }
}
